import React, { Component } from "react";
import { Loader } from "ui-kit-ck-consultant";

import axiosConfig from "../../../utils/axiosConfig";
import AuthContext from "../../../context/AuthContext";
import WidgetWrapper from "./WidgetWrapper";
import CardPerf from "../CardPerf";

export default class WidgetPersonalPerf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
      data: null,
      dataMonth: null,
    };
  }

  static contextType = AuthContext;

  componentDidMount() {
    axiosConfig("home/data", {
      data: { type: 2 },
    }).then((res) => {
      if (res.data.success && res.data.array_performance) {
        const perf = res.data.array_performance;
        this.setState({
          data: perf.user || perf.globale,
          dataMonth: perf.userMonth,
          isLoad: false,
        });
      } else {
        this.setState({ isLoad: false });
      }
    }).catch(() => {
      this.setState({ isLoad: false });
    });
  }

  render() {
    const { data, dataMonth, isLoad } = this.state;

    return (
      <WidgetWrapper
        title="Performance personnelle"
        noCard
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        {isLoad ? (
          <Loader />
        ) : data ? (
          <CardPerf
            NGRA={this.context.name || ""}
            type="globale"
            isLoad={false}
            data={data}
            byMonth={dataMonth}
          />
        ) : (
          <p className="mt-10 mb-10" style={{ textAlign: "center", color: "#999" }}>
            Aucune donnée disponible
          </p>
        )}
      </WidgetWrapper>
    );
  }
}
